import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import SectionHeading from '@/components/base/SectionHeading';
import VideoCard from '@/components/base/VideoCard';
import { getFeatured, getLatest, getHot, allVideos } from '@/lib/videos';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta({
    title: '男同视频 - 多样男同主题视频资源平台',
    description:
      '男同视频为您提供丰富多样的男同主题视频内容，涵盖剧情、短片及专题，方便用户在线观看和了解相关文化与故事。',
    keywords: '男同视频,男同电影,男同短片,男同剧情,男同影视,同性恋视频,男同内容,男同文化',
  });

  const featured = getFeatured();
  const latest = getLatest(10);
  const hot = getHot(8);
  const totalPlays = allVideos.reduce((sum, v) => sum + v.plays, 0);

  return (
    <>
      <HeroCarousel videos={featured} />

      <CategoryEntries />

      <section className="mx-auto w-full max-w-7xl px-4 py-6 md:px-8 md:py-10">
        <SectionHeading
          icon="ri-time-line"
          title="最新上线"
          subtitle="近期更新的男同主题视频作品"
          moreTo="/category/drama"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {latest.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </section>

      <section className="bg-background-100/70">
        <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
          <SectionHeading
            icon="ri-fire-line"
            title="热门推荐"
            subtitle="按播放热度排序的精选内容"
            moreTo="/category/short"
            moreLabel="更多热门"
          />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {hot.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200/80 bg-background-50 p-6 md:grid-cols-2 md:p-10">
          <div className="flex flex-col justify-center gap-4">
            <span className="flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-emotion-happy-line" />
              关于男同视频
            </span>
            <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
              一个专注男同题材影像的文化平台
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
              男同视频汇聚剧情长片、精选短片与深度专题内容，用多样而真诚的影像记录男同群体的情感、
              生活与思考。我们希望帮助每一位观众更轻松地发现喜欢的内容，也更理解镜头背后的文化与故事。
            </p>
            <div className="flex flex-wrap gap-6 pt-2">
              <div className="flex flex-col">
                <span className="text-2xl font-extrabold text-primary-600">{allVideos.length}</span>
                <span className="text-xs text-foreground-500">收录作品</span>
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-extrabold text-accent-600">
                  {(totalPlays / 10000).toFixed(1)}万
                </span>
                <span className="text-xs text-foreground-500">累计播放</span>
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-extrabold text-secondary-600">3</span>
                <span className="text-xs text-foreground-500">内容分类</span>
              </div>
            </div>
            <Link
              to="/about"
              className="mt-2 flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解平台理念
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="relative min-h-[240px] overflow-hidden rounded-lg bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=cinematic%20warm%20library%20of%20film%20stills%20and%20reels%20with%20soft%20golden%20light%2C%20cozy%20arthouse%20aesthetic%2C%20muted%20tones%2C%20no%20people&width=1000&height=800&seq=gv-home-about&orientation=landscape"
              alt="男同视频平台内容展示"
              title="男同视频 - 男同主题影像内容"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </section>
    </>
  );
}